// eslint-disable-next-line import/prefer-default-export
export const SELF_STUDY_PRODUCT_TITLE = 'Ellii Solo'
